import { proxy } from 'valtio';
import { todoCategory } from '@oldDashboard/legacyModels/todoCategory.model';	
import { Template } from '@models/templates.model';
import { Asset } from '@models/assets.model';
import { Comment } from '@oldDashboard/legacyModels/comment.model';


interface ITodoStore {
    todos: todoCategory[];
	templateSelected: Template;
	comments: Comment[];
	commentSelected: Comment;
	currentAssets: Asset[];
	showAttachmentsViewer: boolean;
	currentAttachment: Asset;
}

class TodoStore {
  // Initial state setup
  state = proxy<ITodoStore>({
    templateSelected: {
		id: '',
		name: '',
		description: ''
	},
	todos: [],
	comments:[],
	commentSelected: new Comment,
	currentAssets: [],
	showAttachmentsViewer: false,
	currentAttachment: new Asset
  });

}


export const todoState = proxy(new TodoStore())
